import { IBaseResponse } from 'shared/typings';

export enum EPostbackStatuses {
	PENDING = 'pending',
	REJECTED = 'rejected',
	APPROVED = 'approved',
}

export enum EPostbackMethods {
	GET = 'get',
	POST = 'post',
}

export enum EpostbackParams {
	UUID = 'uuid',
	ORDER_ID = 'order_id',
	OFFER_ID = 'offer_id',
	OFFER_NAME = 'offer_name',
	SOURCE_ID = 'source_id',
	SOURCE_NAME = 'source_name',
	COUNTRY_CODE = 'country_code',
	TITLE = 'title',
	STATUS = 'status',
	AMOUNT = 'amount',
	CURRENCY = 'currency',
	CLICK_TIME = 'click_time',
	ACTIONS_TIME = 'action_time',
	USER_REFERER = 'user_referer',
	USER_AGENT = 'user_agent',
	SUBID_1 = 'subid1',
	SUBID_2 = 'subid2',
	SUBID_3 = 'subid3',
	ERID = 'erid',
	RATE_ID = 'rate_id',
	DETAILED_STATUS = 'detailed_status',
}
export interface IPostback {
	uuid: string;
	source?: {
		uuid: string;
		name: string;
	};
	offer?: {
		uuid: string;
		name: string;
	};
	action_statuses: EPostbackStatuses[];
	method?: EPostbackMethods;
	url: string;
	data?: Record<EpostbackParams, string>;
}

export type TParamNames = {
	[K in EpostbackParams as `${K}_name`]: string;
};

export interface IPostbackForm
	extends Partial<Record<EpostbackParams, string>>,
		Partial<Record<keyof TParamNames, string>> {
	source?: string;
	offer?: string;
	action_statuses: EPostbackStatuses[];
	method?: EPostbackMethods;
	protocol: 'https://' | 'http://';
	url: string;
	params: EpostbackParams[];
}

export interface IPostbackTest {
	method: string;
	url: string;
	json: string;
	status_code: number;
}

export type TPostbackList = IBaseResponse<IPostback[] | null>;
export type TCreatePostbackRequest = Omit<IPostback, 'uuid' | 'source' | 'offer'> & {
	source?: string | null;
	offer?: string | null;
};
export type TUpdatePostbackRequest = Omit<IPostback, 'source' | 'offer'> & {
	source?: string | null;
	offer?: string | null;
};
